<template>
  <div class="mobile-results mx-n3">

    <div>
      <div v-if="running" class="mobile-spinner bg-background position-absolute w-100">
        <spinner></spinner>
      </div>
      <div v-if="noResults || preSearch" class="text-center mt-5">
        <div v-if="noResults">
          <i class="fas fa-search"></i><br>
          לא נמצאו תוצאות
        </div>
        <div v-else>
          <i class="fas fa-arrow-up"></i><br>
          הזן מילת חיפוש בשורת החיפוש
        </div>  
      </div>    
      <b-card no-body v-else>
        <div 
          @click="nextTab"
          ref="scrollBtn"
          class="next-btn position-absolute bg-white rounded-circle">
          <i class="fas fa-arrow-left"></i>
        </div>
        <b-tabs pills card v-model="tabIndex">
          <b-tab active title-link-class="common-pill">
            <template v-slot:title v-if="commonCount > 0" > 
              <span v-if="mode=='rhyme'">חרוזים נפוצים</span>
              <span v-else>מילים נפוצות</span>
              <div>{{commonCount}}</div>
            </template>
            <div class="items-found" v-if="commonCount > 0">נמצאו {{commonCount}} תוצאות</div>
            <b-card-text>
              <ResultsList :activeTab="tabIndex" :list="'common'" @commonResults="updateCommonCount('countItems', ...arguments)"/>            
            </b-card-text>
          </b-tab>
          <b-tab title-link-class="bible-pill">
            <template v-slot:title v-if="bibleResultsCount > 0"> 
              <span v-if="mode=='rhyme'">חרוזים מהתנ״ך</span>
              <span v-else>מילים מהתנ״ך</span>
              <div>{{bibleResultsCount}}</div>
            </template>
            <div class="items-found" v-if="bibleResultsCount > 0">נמצאו {{bibleResultsCount}} תוצאות</div>        
            <b-card-text>
              <BibleResultsList :activeTab="tabIndex" @biblicalResults="updateBiblicalCount('countItems', ...arguments)"/>
            </b-card-text>
          </b-tab>
          <b-tab title-link-class="general-pill">
            <template v-slot:title v-if="rhymeResultsCount > 0"> 
              <span>הרשימה המלאה</span>
              <div>{{rhymeResultsCount}}</div>
            </template>
            <div class="items-found" v-if="rhymeResultsCount > 0">נמצאו {{rhymeResultsCount}} תוצאות</div>        
            <b-card-text>
              <ResultsList :activeTab="tabIndex" :list="'general'" @results="updateCount('countItems', ...arguments)"/>
            </b-card-text>
          </b-tab>
          <b-tab title-link-class="ns-pill">
            <template v-slot:title v-if="nsCount > 0"> 
              <span>ללא סיומת</span>
              <div>{{nsCount}}</div>
            </template>
            <div class="items-found" v-if="nsCount > 0">נמצאו {{nsCount}} תוצאות</div> 
            <b-card-text>
              <ResultsList :activeTab="tabIndex" :list="'ns'" @nsResults="updateNsCount('countItems', ...arguments)"/>
            </b-card-text>
          </b-tab>    
          <b-tab title-link-class="long-pill">
            <template v-slot:title v-if="longCount > 0"> 
              <span v-if="mode=='rhyme'">חרוזים ארוכים</span>
              <span v-else>מילים ארוכות</span>
              <div>{{longCount}}</div>
            </template>
            <div class="items-found" v-if="longCount > 0">נמצאו {{longCount}} תוצאות</div>
            <b-card-text>
              <ResultsList :activeTab="tabIndex" :list="'long'" @longResults="updateLongCount('countItems', ...arguments)"/>
            </b-card-text>
          </b-tab>
          <b-tab title-link-class="fem-pill">
            <template v-slot:title v-if="femCount > 0"> 
              <span>בלשון נקבה</span>
              <div>{{femCount}}</div>
            </template>
            <div class="items-found" v-if="femCount > 0">נמצאו {{femCount}} תוצאות</div>    
            <b-card-text>
              <ResultsList :activeTab="tabIndex" :list="'fem'" @femResults="updateFemCount('countItems', ...arguments)"/>
            </b-card-text>
          </b-tab>
          <b-tab title="temp" disabled><p>I'm a disabled tab!</p></b-tab><!--placeholder for scroll-->  
      </b-tabs>
    </b-card>
    <div id="text-copied-message" class="notify-msg text-white" style="display:none;">
      המילה הועתקה בהצלחה
    </div>
    <div v-if="showMobileBackToTop" @click="scrollToTopMobile"
      class="back-top position-fixed rounded-circle text-center bg-white">
      <i class="fa fa-chevron-up"></i>
    </div>  
  </div>
  </div>  
</template>
<script>
  import BibleResultsList from '@/components/BibleResultsList'
  import ResultsList from '@/components/ResultsList'
  import Spinner from '@/components/spinner'
  import {RunStates} from '@/store/runStates'
  import smoothscroll from 'smoothscroll-polyfill';

  export default {
    name: 'MobileResults',
    components: {BibleResultsList, ResultsList, Spinner},
    data() {
      return {
        initialHeight: 0,
        tabIndex: 0,
        rhymeResultsCount: 0,
        bibleResultsCount: 0,
        commonCount: 0,
        nsCount: 0,
        longCount: 0,
        femCount: 0,
        emptyResults: false,
        showMobileBackToTop: false,
        metaDesc: 'כלי החרוזית מאתר חרוזים, מצלול, אליטרציה ותבנית מילה על בסיס מילת חיפוש. ניתן לסנן את תוצאות החיפוש על ידי הזנת מילים משדה סמנטי מסויים ומאפינים דיקדוקיים.'
      }
    },
    directives: {
      smoothscroll
    },
    created () {
      smoothscroll.polyfill()      
    },
    mounted () {
      this.initialHeight = window.innerHeight
      document.getElementById('app').addEventListener('scroll', this.togglebackBtn)        
      window.addEventListener('resize', this.resized)
      this.$nextTick(function () { 
        if (document.getElementsByClassName('card-header')[0])
          document.getElementsByClassName('card-header')[0].addEventListener('scroll', this.checkScrollEnd)         
      })  
    },
    destroyed () {
      if (document.getElementsByClassName('card-header')[0])
        document.getElementsByClassName('card-header')[0].removeEventListener('scroll', this.checkScrollEnd)
      document.getElementById('app').removeEventListener('scroll', this.togglebackBtn)
      window.removeEventListener('resize', this.resized)
    },     
    methods: {
      resized () { //for ios orientation change when address/toolbar disapeear
       if (navigator.userAgent.match(/ipad|iphone/i)) { 
        let tempHeight = window.innerHeight
        if (tempHeight < this.initialHeight) {
          document.getElementsByTagName( 'html' )[0].classList.remove('rotated')
        } else {
          document.getElementsByTagName( 'html' )[0].classList.add('rotated')
        }
       } 
      },      
      scrollToTopMobile () {
        document.getElementById('app').scroll({ top: 0, left: 0, behavior: 'smooth' })
      },
      togglebackBtn () {
        this.showMobileBackToTop = document.getElementById('app').scrollTop > 300
      },
      checkScrollEnd () {
        let cardHeader = document.getElementsByClassName('card-header')[0]
        let leftPos = cardHeader.scrollLeft
        if (Math.abs(leftPos) + cardHeader.clientWidth >= cardHeader.scrollWidth-50) {
          this.$refs.scrollBtn.classList.add('text-secondary')
        } else {
          this.$refs.scrollBtn.classList.remove('text-secondary')
        }          
      },
      nextTab () {
        let cardHeader = document.getElementsByClassName('card-header')[0]
        let leftPos = cardHeader.scrollLeft
        cardHeader.scroll({ top: 0, left: leftPos-190, behavior: 'smooth' })           
      },
      updateCount: function(countItems, value, fMore) {
        if (this.commonCount > 0)
          this.tabIndex = 0
        if(this.commonCount == 0 && this.bibleResultsCount == 0) {
          if (value > 0) {
            this.tabIndex = 2
          }
        }
        this.rhymeResultsCount = value
        this.rhymeMore = fMore
      },
      updateBiblicalCount: function(countItems, value, fMore) {
        if(this.commonCount == 0) {
          if (value > 0) {
            this.tabIndex = 1
          }
        }
        this.bibleResultsCount = value
        this.bibleMore = fMore
      },
      updateCommonCount: function(countItems, value, fMore, topTenResults) { 
        this.commonCount = value
        this.commonMore = fMore
        if (this.loading === 'Complete') {
          var desc = 'חרוזים למילה ' + this.searchWord + ': ' + topTenResults + ' ועוד... '
          desc += this.metaDesc
          document.querySelector('meta[name="description"]').setAttribute("content", desc)
        }        
      },
      updateNsCount: function(countItems, value, fMore) {
        if(this.commonCount == 0 && this.bibleResultsCount == 0 && this.rhymeResultsCount == 0) {
          if (value > 0) {
            this.tabIndex = 3
          }
        }
        this.nsCount = value
        this.nsMore = fMore
      },
      updateLongCount: function(countItems, value, fMore) {
        if(this.commonCount == 0 && this.bibleResultsCount == 0 && this.rhymeResultsCount == 0 && this.nsCount == 0) {
          if (value > 0) {
            this.tabIndex = 4
          }
        }        
        this.longCount = value
        this.longMore = fMore
      },
      updateFemCount: function(countItems, value, fMore) {
        if(this.commonCount == 0 && this.bibleResultsCount == 0 && this.rhymeResultsCount == 0 && this.nsCount == 0 && this.longCount == 0) {      
          if (value > 0) {
            this.tabIndex = 5
          } else {
            // no results found
            if (this.loading === 'Complete') {
              this.emptyResults = true
            }
          }
        }        
        this.femCount = value
        this.femMore = fMore
      }
    },
    computed: {
      hebrew () {
        return this.$settings.hebrew
      },
      preSearch () {
        return this.$store.state.charuzitApiState === RunStates.NOT_RUN
      },
      running () {
        return this.$store.state.charuzitApiState === RunStates.RUNNING
      },
      complete () {
        return this.$store.state.charuzitApiState === RunStates.COMPLETE
      },
      noResults () {
        return this.$store.state.noResults || this.emptyResults
      },
      mode () {
        return this.$store.state.searchModel
      },
    }
  }
</script>
<style>
  .modal-open .back-top {display: none;}
  .back-top {
    bottom: 15px;
    left: 15px;
    height: 60px;
    width: 60px;
    line-height: 60px;
    z-index: 1;
    box-shadow: 0 0 11px 0 rgba(0, 0, 0, 0.2);
  }
</style>
<style lang="scss">
.mobile-spinner {
  padding-top:20vh;
  min-height: 60vh;
  height: calc(100% + 40px);
  z-index:9;
}
#text-copied-message {
  &.notify-msg {
    left: 50%;
    margin-left: -118px;
  }
}
.mobile-results {
  .next-btn {
    left: 0;
    top: 15px;
    padding: 13px 16px;
    //border-radius: 0 30px 30px 0;
    width: 48px;
    height: 48px;
    box-shadow: 0 0 11px 0 rgba(0, 0, 0, 0.2);
  }
  .card {
    border: none;
    background: none;
  }
  .card-body {
    padding: 0;
    .items-found {
      padding: 7px 20px 5px;
      font-size: 20px;
    }
    .card-text {
      background: white;
      border-radius: 16px;
      box-shadow: 0 0 11px 0 rgba(0, 0, 0, 0.08);
      padding: 20px;      
      li {
        width: 49%;
        @media screen and (orientation:landscape) { 
          width: 24%;
          margin-left: 1.3%!important;
          &:nth-child(4n) {
            margin-left:0!important;
          }
          &:nth-child(even) {
            margin-right: 0!important;
          } 
        }
        height: 42px;
        text-align: center;        
        &.mobile-bible-item {          
          width: 100%;
          overflow-x: hidden;
          height: auto;
          line-height: 33px;
          p {
            max-width: 93%;
            margin: auto!important;
          }
          b {font-weight: normal!important;text-decoration: none!important;}         
          &:nth-child(odd), &:nth-child(even) {
            margin-right: 0;
            margin-left: 0
          }
          small {
            display: block;            
          }             
        }
        display: inline-block;
        margin-bottom: 7px;
        background: #f6f6f6;
        border-radius: 6px;
        font-size: 26px;
        p {
                   
        }
        i {     
          top: 12px!important;
          position: absolute;
          right: 15px;
          font-size: 17px;         
          color: #8d8d8d;
        }
        &:nth-child(odd) {
          margin-left: 1%;  
        }
        &:nth-child(even) {
          margin-right: 1%;  
        }        
        small {
          display: none;
        } 
      }  
    }
  }
  .card-header {
    overflow-x: scroll;
    scroll-behavior: smooth;
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
    background: none;
    border: none;
    padding: 0 15px 0 90px;
    margin: 15px 0;    
    .nav {
      flex-wrap: unset;
      width: auto;
      padding: 1px 15px;
      .nav-item {
        margin-left: 8px;
        &:last-child {
          //margin-left: 0;
        }  
        .nav-link {
          white-space: nowrap;
          border-radius: 24px;
          color: #000;
          background: white;
          padding: 0;
          border: 1px solid #e3e3e3;
          &.disabled {visibility: hidden;}
          &:focus {
            outline: none!important;
          }
          span {
            padding: .75rem 1rem .75rem 0;
            display: inline-block;
          }
          &.active {
            color: var(--primary);
            border: 1px solid var(--primary);
            div {              
              background: #d6ecff;
              color: var(--primary);
            }
          }
          div {
            margin-right: 10px;
            margin-left: 1rem;
            padding:0 7px;
            line-height: 20px;
            display: inline-block;
            border-radius: 10px;
            background: #e3e3e3;            
          }  
        }
      }  
    }
  }
}  
</style>